<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    
    export default {
      page: {
        title: process.env.VUE_APP_NAME,
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner
    
      },
      mixins: [apigeneric],
      data() {
        return {
          DefaultPage: 1,
          Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },
          title: this.$t('StrAnasayfa.Title'),
          ActivityData: {},
          ActivitiesTitle: {},
          LangId: this.$route.params.LangId,
          ActivityId: this.$route.params.ActivityId,
          items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true,  
        };
      },
      methods: {
        Get() {
          if (this.LangId == 'tr') {
            this.ActionsSingleGet({
              Service: "activities",
              Id: this.ActivityId
            }).then((res) => {
              this.ActivityData = res.Data;
            });
          } else {
    
            this.ActionsFilterGet({
              Service: "languages",
              Page: this.Page,
              Filter:
                "&shortlangtitle=" + this.LangId
            }).then((res) => {
              for (let LangData in res.Data) {
                this.ActionsFilterGet({
                  Service: "activitytranslations",
                  Page: this.Page,
                  Filter: "&Langid=" + res.Data[LangData].Id + "&Activityid=" + this.ActivityId
                }).then((res) => {
                  this.ActivityData = res.Data[0];
                  console.log(res)
                  if(res.TotalCount == 0){
                      localStorage.setItem("lang", "tr");
                      window.location.reload();
              
            }
                  
                  
    
                });
              }
    
            });
    
          }
          this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=9c0688d8-02a8-4e54-bf39-bc8d5cdeb75f"
          }).then((res) => {
            this.ActivitiesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
        }
      },
    };
    </script>
        
    <template>
      <Loader>
        <Layout>
          <Banner />
          <div class="title c-flex flex-column mt-2 col-md-4 mx-auto" style="border: 2px solid black; border-radius: 5px; opacity: 5px">
              <h3 style="color: black">{{ActivitiesTitle[0].Resourcevalue}}</h3>
            </div>
          <div class="news-detail">
        <div class="title c-flex flex-column mb-2 col-md-2 mx-auto">
          <h2>{{ActivityData.Title}}</h2>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-10 mx-auto">
              <div class="news">
                <div class="image">
                  <img :src="$config.FILES_URL + 'web/' + ActivityData.Imagegallery" alt="">
                </div>
                <div class="new-header justify-content-end">
                  <div class="new-date">
                    <span class="date">{{ActivityData.Created | formatDateTime}}</span>
                  </div>
                </div>
                <div class="new-content">
                  <span v-html="ActivityData.Description"></span><br />
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
        </Layout>
      </Loader>
    </template>
        